export * from './types';

import { mapApiLivestream } from '@/mappers/livestream';
import type { AxiosInstance, AxiosResponse } from 'axios';
import type { ILivestreamData } from '@/entities';
import type { IApiResponse } from '@/services';
import type { IApiLivestreamResponse } from '@/services/api/livestream/types';

export class ApiLivestreamEndpoint {
  axios: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axios = axiosInstance;
  }

  async fetchLivestreams(locale: string): Promise<ILivestreamData[]> {
    const response: AxiosResponse<IApiResponse<IApiLivestreamResponse[]>> = await this.axios
      .get(`livestreams?locale=${encodeURIComponent(locale)}`)
      .catch(() => Promise.reject());

    if (response?.data.data) {
      return response.data.data.map((r) => mapApiLivestream(r));
    }

    return Promise.reject();
  }

  async fetchPastLivestreams(locale: string): Promise<ILivestreamData[]> {
    const response: AxiosResponse<IApiResponse<{ pagedList: IApiLivestreamResponse[] }>> = await this.axios
      .get(`livestreams/past?locale=${encodeURIComponent(locale)}&pageNumber=1&pageSize=9`)
      .catch(() => Promise.reject());

    if (response?.data.data) {
      return response.data.data.pagedList.map((r) => mapApiLivestream(r));
    }

    return Promise.reject();
  }
}
